let _ctx = null;

const getCtx = () => {
  if (!_ctx) _ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (_ctx.state === 'suspended') _ctx.resume();
  return _ctx;
};

const tone = (freq, start, dur, vol = 0.3, type = 'sine') => {
  const c = getCtx();
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, start);
  gain.gain.linearRampToValueAtTime(vol, start + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  osc.connect(gain);
  gain.connect(c.destination);
  osc.start(start);
  osc.stop(start + dur);
};

// Soft three-tone bell chord — A4 / A5 / E6 harmonic series
export const playBell = () => {
  try {
    const c = getCtx();
    const t = c.currentTime;
    tone(440, t,        2.8, 0.22);
    tone(880, t + 0.01, 2.0, 0.11);
    tone(1320, t + 0.02, 1.4, 0.055);
  } catch { /* AudioContext unavailable */ }
};

export const playTick = () => {
  try {
    const c = getCtx();
    tone(1000, c.currentTime, 0.04, 0.03, 'square');
  } catch { /* noop */ }
};

// Call on first user interaction to satisfy browser autoplay policy
export const unlockAudio = () => {
  try { getCtx(); } catch { /* noop */ }
};
